import { defineComponent as _defineComponent } from 'vue'
import LegPickerForm from './LegPickerForm.vue'
import type { GroupAnchorDraft } from '@/stores/transportation'
import type { Transportation } from '@/types/transportation'


export default /*#__PURE__*/_defineComponent({
  __name: 'LegPickerSheetMobile',
  props: {
    open: { type: Boolean },
    transportation: null,
    seedFromWaypointId: null,
    value: null,
    arrival: null,
    departure: null,
    seedIsArrival: { type: Boolean },
    seedIsDeparture: { type: Boolean },
    seedOriginName: null,
    seedDestinationName: null,
    arrivalLocationInvalid: { type: Boolean },
    departureLocationInvalid: { type: Boolean }
  },
  emits: ["input", "update:arrival", "update:departure", "close"],
  setup(__props: any) {





return { __sfc: true,LegPickerForm }
}

})